import React, { useEffect, useState, useRef, useContext } from 'react';

//*************************Componentes PrimerReact**************************************** */
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';

import AgGrid from '../../../../../../Base/Components/Tables/AgGrid/AgGrid';
import Loader from '../../../../../../Base/Components/Loader/Loader';
import { AuthContext } from '../../../../../../Base/Context/AuthContext/AuthContext';
import { getOrdenesDetallesCompletos } from '../../../../../../API/Compras/Ordenes/OrdenesComprasRequests';


const OverlayOCD = ({onChange, detalles, IdPurchaseOrder, habilitar, close, Servicios}) => {

    const op = useRef(null);
    const buttom = useRef(null)
    const [loading, setLoading] = useState(false);
    const [ordenesC, setOrdenesC] = useState([]);

    const { userAuth } = useContext(AuthContext)
    const [hiddenPriceColumn, setHiddenPriceColumn] = useState(userAuth?.AccessWeb.split(",").map((e) => parseInt(e)).includes(29));

    const obtenerOrdeneC = async () => {
        setLoading(true)

        const ordenesTempo = await getOrdenesDetallesCompletos(IdPurchaseOrder)
        setOrdenesC(ordenesTempo)

        setLoading(false)
    }

    const colums = [
        {
            field: 'IdPurchaseOrderDetail',
            header: 'ID',
            headerEn: 'ID',
            className: 'XXsmall',
            hidden: userAuth.IdRol === 1,
            frozen:true,
        },
        {
            field: 'PurchaseOrder',
            header: 'OC',
            headerEn: 'PO',
            className: 'Xsmall',
            Sumary: 'count',
            frozen:true,
        },
        {
            field: 'CustomerName',
            header: 'Proveedor',
            headerEn: 'Customer',
            className: 'small',
        },
        {
            field: 'UserNameAgente',
            header: 'Agente',
            headerEn: 'Agent',
            className: 'medium',
        },
        {
            field: 'Area',
            header: 'Area',
            headerEn: 'Area',
            className: 'small',
        },
        {
            field: 'Currency',
            header: 'Moneda',
            headerEn: 'Currency',
            className: 'Xsmall',
        },
        Servicios ? 
        {
            field: 'BalanceReservado',
            header: 'Balance',
            headerEn: 'Balance',
            className: 'Xsmall',
            Format: "Currency",
        } :
        {
            field: 'Balance',
            header: 'Balance',
            headerEn: 'Balance',
            className: 'Xsmall',
            Format: "Currency",
        },
        {
            field: 'SubTotal',
            header: 'SubTotal',
            headerEn: 'SubTotal',
            hidden: hiddenPriceColumn,
            Format: 'Currency',
            className: 'Xsmall',
        },
        {
            field: 'ISVTotal',
            hidden: hiddenPriceColumn,
            header: 'ISV',
            headerEn: 'TAX',
            Format: 'Currency',
            className: 'Xsmall',
        },
        {
            field: 'Discount',
            hidden: hiddenPriceColumn,
            header: 'Desc.',
            headerEn: 'Disc.',
            Format: 'Currency',
            className: 'Xsmall',
        },
        {
            field: 'Total',
            header: 'Total',
            headerEn: 'Total',
            hidden: hiddenPriceColumn,
            Format: 'Currency',
            className: 'Xsmall',
        },
    ]
    
    const table = {
        Data: ordenesC,
        Columns: colums,
        onCellClicked: e => onChange(e, op)
    }

    const openOver = (e) => {
        op.current.toggle(e)
        setLoading(true)
        obtenerOrdeneC()
    }


    return (
        <div style={{ maxWidth: '55vw' }}>

            <div className="p-inputgroup">
                <Button ref={buttom} icon='pi pi-plus' type="button" onClick={(e) => openOver(e)} disabled={!habilitar}/>
            </div>

            <OverlayPanel ref={op} showCloseIcon dismissable={false} onHide={close} style={{ height: '30vh', width: '42vw' }} >
                <Loader loading={loading} querySelector={'#ProveedoresCAIS'} />
                <div style={{ width: '40vw', height: '30vh' }} id='ProveedoresCAIS'>
                    <AgGrid table={table} />
                </div>
            </OverlayPanel>
        </div>
    )
}

export default OverlayOCD